import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=752d1e4d&scoped=true"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=752d1e4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752d1e4d",
  null
  
)

export default component.exports